// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Dp4u","requiredAsterisk":"Info_requiredAsterisk__1ACGv"};